import { gql } from '@apollo/client';

import { AuthTokensFragment } from '@modules/auth/graphql';

export const ChangeUsernameMutation = gql`
    mutation ChangeUsername($currentPassword: String!, $newUsername: String!) {
        changeUsername(currentPassword: $currentPassword, newUsername: $newUsername) {
            ...AuthTokens
        }
    }
    ${AuthTokensFragment}
`;
